<template>
  <ChangePasswordPage
    :newPassword="true"
    @onChangePassword="onChangePassword"
  />
</template>

<script>
import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import forgetPasswordModel from "@/models/forget-password/forget-password";
import ChangePasswordPage from "@/views/pages/authentication/login/components/ChangePassword.vue";

export default {
  components: {
    ChangePasswordPage,
  },

  setup() {
    const {
      openErrorModal,
      openDefaultErrorModal,
      openSuccessModal,
      closeValidationModal,
    } = useValidationModal();

    const { decodeParamToken } = useDecodeToken();
    const { passwordRecovery } = forgetPasswordModel();

    let decodeToken = null;

    const onRedirect = () => {
      router
        .replace({
          path: "/login",
          query: { brandRef: decodeToken.brand_ref },
        })
        .catch(() => {});
    };

    const onChangePassword = (passwordForm) => {
      if (!passwordForm) return;
      if (!decodeToken) return;

      window.$loading(true);
      passwordRecovery.payload.token = decodeToken.token;
      passwordRecovery.payload.tx_reference = decodeToken.tx_reference;
      passwordRecovery.payload.new_password = btoa(passwordForm.newPassword);
      store
        .dispatch("api/apiRequest", passwordRecovery)
        .then((response) => {
          openSuccessModal(
            "ตั้งค่ารหัสผ่านสำเร็จ",
            "*กล่องข้อความนี้จะปิดอัตโนมัติ",
            null,
            () => {
              router
                .replace({
                  path: "/login",
                  query: { brandRef: decodeToken.brand_ref },
                })
                .catch(() => {});
            },
            () => {
              router
                .replace({
                  path: "/login",
                  query: { brandRef: decodeToken.brand_ref },
                })
                .catch(() => {});
            }
          );

          // auto close modal and redirect url
          setTimeout(() => {
            closeValidationModal(onRedirect());
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          openErrorModal(
            error.data.error.locale["th-th"].title,
            error.data.error.locale["th-th"].message
          );
        })
        .finally(() => {
          window.$loading(false);
        });
    };

    onBeforeMount(() => {
      if (decodeParamToken()) decodeToken = decodeParamToken();
    });

    return { onChangePassword };
  },
};
</script>
